var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['news-item',  ("news-item-" + (_vm.item.template))]},[(_vm.item.template == 3)?_c('news-tpl-3',{attrs:{"item":_vm.item}}):_c('news-tpl-4',{attrs:{"item":_vm.item}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa2592a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/component/news-stream/news-item.vue
// module id = null
// module chunks = 